import React, { Component } from 'react';
import style from './Header.css';
import CountDown from '../../components/CountDown/';
import { toTime } from '../../lib/utils';

class Header extends Component {
  render() {
    return (
    <div className={style.header}>
      <div className={style.invalidName}>
       <img className={style.cover} src="https://webcdn.17app.co/golden_feather/result/logo.png" />
        <div className={style.caption}>
          距離金羽獎剩餘
        </div>
      </div>
      <CountDown endTime={toTime('2017-05-27T16:00:00+08:00')} />
    </div>);
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/sections/Header/index.js